import React, { ReactNode } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'

import styles from './styles.module.scss'

interface PersonSectionProps {
  title: ReactNode
  subtitle: ReactNode
  children?: ReactNode
  onOpenDrawer: () => void
  disableAddPersonButton: boolean
}

const PersonSection = ({ title, subtitle, onOpenDrawer, children, disableAddPersonButton }: PersonSectionProps) => {
  const [getClassName] = useNameFormatter('PersonSection')
  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('header')]}>
        <div>
          {title}
          <div className={styles[getClassName('subtitle')]}>{subtitle}</div>
        </div>
        <div className={styles[getClassName('add-button-wrapper')]}>
          <BasicButton
            disabled={disableAddPersonButton}
            type={BASIC_BUTTON_TYPE_OUTLINED}
            onClick={onOpenDrawer}
          >
            <FormattedMessage
              defaultMessage='Add person'
              id='sputnik.PeopleInfoForm__bLmnuX'
            />
          </BasicButton>
        </div>
      </div>
      {children}
    </div>
  )
}

export default PersonSection
